export const COLORS = {
  light: {
    text: 'var(--blackish)',
    textTitle: 'var(--black)',
    background: 'var(--white)',
    primary: '#5596d0',
  },
  dark: {
    text: 'var(--whitish)',
    textTitle: 'var(--white)',
    background: 'var(--dark-grey)',
    primary: '#58b1ff',
  },
};
